import { IRootState } from '@/store';
import { ActionTree } from 'vuex';
import { ITreuhandEinstellungenState } from './state';

import { LOADING_BENUTZER, MAPBENUTZERDATA, MAPBENUTZERDETAILS, MAPTREUHANDBENUTZERDATA } from './mutations';
import { NAME } from './';

import { benutzerinfoService } from '../services/BenutzerinfoService';
import { CLOSE_MODAL, NEW_MODAL_ERROR, NEW_SUCESS } from '@/store/modules/headerNotification/actions';
import { SHOW, HIDE } from '@/store/modules/loadingSpinner/actions';
import { BenutzerCreateApiDto, BenutzerEditApiDto } from '@/api-schema';
import { BenutzerInfoSearchApiDto } from '@/types/BenutzerInfoSearchApiDto';
import { treuhandProfilService } from '../services/TreuhandProfilService';
import { i18n } from '@/plugins/i18n';
import { profilService } from '@/areas/kunde/profileinstellungen/services/ProfilService';

export const GET_BENUTZER = 'GetBenutzer';
export const GET_BENUTZER_DETAILS = 'getBenutzerDetails';
export const DELETE_ACCOUNT = 'deleteBenutzerAccount';
export const EDIT_ACCOUNT = 'editBenutzerAccount';
export const GET_EDIT_ACCOUNT = 'getAccountToEdit';
export const ADD_ACCOUNT = 'addBenutzerAccount';
export const GET_BENUTZER_BY_ID = 'getTreuhandBenutzer';
export const RESET_MFA = 'resetMfa';

export const actions: ActionTree<ITreuhandEinstellungenState, IRootState> = {
    async [GET_BENUTZER]({ dispatch, commit, state }: any) {
        console.debug(NAME + '::' + GET_BENUTZER);

        commit(LOADING_BENUTZER, true);
        const searchQuery: BenutzerInfoSearchApiDto = Object.assign({}, state.benutzerFilter);
        await benutzerinfoService
            .getByEmail(searchQuery)
            .then((response) => {
                commit(MAPBENUTZERDATA, response);
            })
            .catch(() => {
                commit(MAPBENUTZERDATA, null);
            })
            .finally(() => {
                commit(LOADING_BENUTZER, false);
            });
    },
    [ADD_ACCOUNT]({ dispatch, state }: any, benutzer: BenutzerCreateApiDto) {
        console.debug(NAME + '::' + ADD_ACCOUNT, benutzer);
        dispatch('loadingSpinner/' + SHOW, {}, { root: true });
        dispatch('headerNotification/' + CLOSE_MODAL, {}, { root: true });

        return treuhandProfilService
            .addBenutzer(benutzer)
            .then((response) => {
                dispatch(GET_BENUTZER_BY_ID);
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                return true;
            })
            .catch((response) => {
                dispatch('headerNotification/' + NEW_MODAL_ERROR, { text: i18n.global.t('einstellungen.errormessage.duplicateaccount') }, { root: true });
                dispatch('loadingSpinner/' + HIDE, {}, { root: true });
                return false;
            });
    },
    [GET_BENUTZER_DETAILS]({ commit }: any, id: string) {
        console.debug(NAME + '::' + GET_BENUTZER_DETAILS, id);

        treuhandProfilService.getBenutzerDetails(id).then((response) => {
            commit(MAPBENUTZERDETAILS, response, id);
        });
    },
    [EDIT_ACCOUNT]({ dispatch }: any, benutzer: BenutzerEditApiDto) {
        console.debug(NAME + '::' + EDIT_ACCOUNT, benutzer);

        return treuhandProfilService.editBenutzer(benutzer).then((response) => {
            if (response.isSuccess) {
                dispatch(GET_BENUTZER_BY_ID);
            }
        });
    },
    async [GET_EDIT_ACCOUNT]({ commit }: any, objectBenutzerId: string) {
        console.debug(NAME + '::' + GET_EDIT_ACCOUNT, objectBenutzerId);

        return treuhandProfilService.getEditAccount(objectBenutzerId).then((response) => {
            return response;
        });
    },
    [DELETE_ACCOUNT]({ dispatch }: any, objectBenutzerId: string) {
        console.debug(NAME + '::' + DELETE_ACCOUNT, objectBenutzerId);

        return treuhandProfilService.deleteBenutzer(objectBenutzerId).then((response) => {
            if (response) {
                dispatch(GET_BENUTZER_BY_ID);
            }
        });
    },
    [GET_BENUTZER_BY_ID]({ commit, state, dispatch }: any) {
        console.debug(NAME + '::' + GET_BENUTZER_BY_ID);
        treuhandProfilService.getBenutzer().then((response) => {
            commit(MAPTREUHANDBENUTZERDATA, response);
        });
    },
    [RESET_MFA]({ dispatch }: any, objectBenutzerId: string) {
        console.debug(NAME + '::' + RESET_MFA, objectBenutzerId);
        return treuhandProfilService
            .resetMfa(objectBenutzerId)
            .then((response) => {
                if (response) {
                    dispatch('headerNotification/' + NEW_SUCESS, { text: i18n.global.t('einstellungen.success.resetmfa') }, { root: true });
                }
            })
            .catch((response) => {
                dispatch('headerNotification/' + NEW_MODAL_ERROR, { text: i18n.global.t('einstellungen.errormessage.resetmfa') }, { root: true });
            });
    }
};
